import { render, staticRenderFns } from "./Ace.split.component.vue?vue&type=template&id=d406c22a&"
import script from "./Ace.split.component.vue?vue&type=script&lang=js&"
export * from "./Ace.split.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports